import Box from "@mui/material/Box";
import LogoAsset from "../../../assets/Logo.svg";

const Logo = () => {
  return (
    <Box
      component="img"
      sx={{
        height: 48,
      }}
      alt="Earthly Logo"
      src={LogoAsset}
    />
  );
};

export default Logo;
